import { apiFetch } from './client.js';

/**
 * A family's Lesson credits (031; boards C1-C5, approved 27 October):
 * GET/POST /api/coach/families/{accountId}/credits for the coach (the API's
 * credit-removals stays for back-end corrections; the app has no Remove); GET /api/credits for a parent's own Remaining credits.
 */
export interface FamilyCreditService {
  service_id: string;
  name: string;
  remaining: number;
}

export interface FamilyCreditLine {
  at: string;
  kind: 'added' | 'used' | 'removed';
  service_id: string;
  quantity: number;
  by: string | null;
  lesson_start: string | null;
  reason: string | null;
}

export interface FamilyCredits {
  may_manage: boolean;
  services: FamilyCreditService[];
  history: FamilyCreditLine[];
}

type GetToken = () => Promise<string | null>;
const path = (accountId: string) => `/api/coach/families/${encodeURIComponent(accountId)}/credits`;

export function readFamilyCredits(getToken: GetToken, accountId: string): Promise<FamilyCredits> {
  return apiFetch(path(accountId), getToken);
}

export function addFamilyCredits(getToken: GetToken, accountId: string, serviceId: string, quantity: number): Promise<FamilyCredits> {
  return apiFetch(path(accountId), getToken, {
    method: 'POST',
    body: JSON.stringify({ service_id: serviceId, quantity }),
  });
}

/** A parent's own, by service; a service with none left is absent (list-credits.ts). */
export async function readMyCredits(getToken: GetToken): Promise<{ service_name: string; remaining: number }[]> {
  const body = await apiFetch<{ credits: { service_name: string; remaining: number }[] }>('/api/credits', getToken);
  return body.credits;
}
